export default __webpack_public_path__ + "static/TheEuropeannationkeepingusyoung-e9e5e140102b0f93d5214f3b744d1720.jpg";